import { render, staticRenderFns } from "./Recscard.vue?vue&type=template&id=aefb91d8&scoped=true&"
import script from "./Recscard.vue?vue&type=script&lang=js&"
export * from "./Recscard.vue?vue&type=script&lang=js&"
import style0 from "./Recscard.vue?vue&type=style&index=0&id=aefb91d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefb91d8",
  null
  
)

export default component.exports